/* unplugin-vue-components disabled */import script from "./UrlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UrlPage.vue?vue&type=script&setup=true&lang=js"

import "./UrlPage.vue?vue&type=style&index=0&id=778637c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778637c2"]])

export default __exports__